import { render, staticRenderFns } from "./RootBarView.vue?vue&type=template&id=3ea19fa4&"
import script from "./RootBarView.vue?vue&type=script&lang=ts&"
export * from "./RootBarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports